import { Controller } from "stimulus"

export default class extends Controller {
	static targets = ["element"]

  connect() {
    if (!this.hasElementTarget) return
    var onconnect = this.elementTarget.getAttribute('data-onconnect')
    if (onconnect === 'true'){
     this.toggleClass()
    }
  }

	toggleClass(event) {
		// Only prevent if explicitly asked
		const shouldPrevent = this.element.dataset.preventDefault === "true"

		if (shouldPrevent) {
			event?.preventDefault()
			event?.stopPropagation()
		}

		const targets = this.elementTargets
		targets.forEach((e) => {
			const elementIdAttr = e.getAttribute("data-element-id")
			const classAttr = e.getAttribute("data-class")

			if (!elementIdAttr || !classAttr) return

			const els = elementIdAttr.split(" ")
			const cls = classAttr.split(" ")

			els.forEach(el => {
				const elRef = document.getElementById(el)
				if (elRef) cls.forEach(cl => elRef.classList.toggle(cl))
			})
		})
	}
}
